import { useEffect, useRef } from "react";
import { useScrollReveal } from "../useScrollReveal";

function SkillBar({ skill }) {
  const barRef = useRef(null);
  const [ref, visible] = useScrollReveal(0.3);

  useEffect(() => {
    if (visible && barRef.current) {
      barRef.current.style.transform = `scaleX(${skill.level})`;
    }
  }, [visible, skill.level]);

  return (
    <div ref={ref} style={{
      background: "var(--white)", border: "1px solid var(--border)",
      borderRadius: "var(--radius)", padding: "1rem 1.25rem",
    }}>
      <div style={{ fontSize: "0.9rem", fontWeight: 500, marginBottom: "0.25rem" }}>{skill.name}</div>
      <div style={{ fontSize: "0.78rem", color: "var(--text-muted)" }}>{skill.sub}</div>
      <div style={{ height: 3, background: "var(--border)", borderRadius: 999, marginTop: "0.6rem", overflow: "hidden" }}>
        <div ref={barRef} style={{
          height: "100%", background: "var(--text-main)", borderRadius: 999,
          transformOrigin: "left", transform: "scaleX(0)",
          transition: "transform 1s ease 0.2s",
        }} />
      </div>
    </div>
  );
}

export default function About({ data }) {
  const [ref, visible] = useScrollReveal();

  return (
    <section id="about" style={{ padding: "6rem 0", background: "var(--off-white)" }}>
      <div className="section-inner">
        <div className="section-label">About</div>
        <h2 className="section-title">Code as craft, <em>quality as habit</em></h2>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4rem", alignItems: "start" }} className="about-grid">
          <div ref={ref} style={{ opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(24px)", transition: "all 0.6s ease" }}>
            {data.bio.map((p, i) => (
              <p key={i} style={{
                fontSize: "1.05rem", color: "var(--text-secondary)",
                lineHeight: 1.75, fontWeight: 300, marginBottom: i < data.bio.length - 1 ? "1.25rem" : 0,
              }}>{p}</p>
            ))}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
            {data.skills.map((s) => <SkillBar key={s.name} skill={s} />)}
          </div>
        </div>
      </div>

      <style>{`
        .about-grid { grid-template-columns: 1fr 1fr; }
        @media (max-width: 768px) { .about-grid { grid-template-columns: 1fr !important; gap: 2rem !important; } }
      `}</style>
    </section>
  );
}
